<template>
  <div class="board-canvas relative flex-grow">
    <div
      v-if="pipeline"
      :key="projectId"
      :class="[
        'board',
        'absolute',
        'inset-0',
        'select-none',
        'whitespace-nowrap',
        'mb-2',
        'pb-2',
        'px-1',
        'overflow-x-auto',
        'overflow-y-hidden',
      ]"
    >
      <PipelineStage
        ref="pipelineStages"
        v-for="pipelineStage in pipelineStages"
        :key="pipelineStage.id"
        :pipeline="pipeline"
        :pipeline-stage="pipelineStage"
        :last-focused-contact-request="lastFocusedContactRequest"
        :assigned-to-me="assignedToMe"
        :project-id="projectId"
        @edit="editContactRequest"
      />
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash-es';
import PipelineStage from './PipelineStage.vue';

export default {
  components: {
    PipelineStage,
  },

  props: {
    accountId: {
      type: String,
      default: null,
    },
    pipeline: {
      type: Object,
      required: true,
    },
    assignedToMe: Boolean,
    projectId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      lastFocusedContactRequest: null,
    };
  },

  computed: {
    pipelineStages() {
      return sortBy(this.pipeline.pipelineStages.slice(), 'order');
    },
  },

  methods: {
    editContactRequest(contactRequest) {
      this.lastFocusedContactRequest = contactRequest.id;

      const vm = this;

      this.$modal.show({
        component: 'ContactRequestModal',
        props: {
          contactRequestId: contactRequest.id,
        },
        on: {
          'pipeline-stage-change': ({ contactRequestId, to, from }) => {
            vm.$store.commit('ui/pipelineStageContactRequests/removeIdFromParent', {
              parentId: from,
              id: contactRequestId,
            });

            vm.$store.commit('ui/pipelineStageContactRequests/addIdToParent', {
              parentId: to,
              id: contactRequestId,
            });
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
